
import { Component, Vue, toNative } from 'vue-facing-decorator';
import { ApplicationViewModel } from '@/entities/Application/ApplicationViewModel';
import loading from '@/components/Common/loading.vue';
import LicenseDetails from '@/components/Application/LicenseDetails.vue';
import LatestNews from '@/components/Application/LatestNews.vue';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import { StoreHelper } from '@/store/StoreHelper';
import { ProgramSignalRModel } from './signalRRequest/Program/ProgramSignalRModel';
import NotificationPopup from './components/Common/NotificationPopup.vue';
import { BrowserSettingsInfo } from './entities/BrowserSettingsInfo';
import { AppColorSettingsInfo } from './entities/Application/AppColorSettingsInfo';
// import OnboardingInstructions from '@/components/Application/OnboardingInstructions.vue';
import TrialPackageIndicator from '@/components/Application/TrialPackageIndicator.vue';
import { NavBarImages } from '@/entities/Application/NavBarImages';
import * as hub from '@/hubs/hub';
import { EnvironmentBaseURL, Store, app, Root, FetchData, Authorization } from './main';
import { ApplicationItem } from '@/entities/Application/Application';
import { useRoute } from 'vue-router';
import FreezeScreen from '@/entities/Emits/Common/FreezeScreen';
import { EventItem } from './entities/ApplicationInstance/EventItem';
import { UserInformation } from './entities/UserInformation';
import ModuleTypeEnum from './enums/ModuleTypeEnum';
import '@progress/kendo-theme-default/dist/all.css'; // Add Kendo CSS
import TopNavBar from './components/Application/NavigationPanel/TopNavBar.vue';
import LeftMenuPanel from './components/Application/NavigationPanel/LeftMenuPanel.vue';
import { EventSideMenu } from './entities/Application/EventSideMenu';
import { ApplicationSideMenu } from './entities/Application/ApplicationSideMenu';
import { AppNavBarImages } from './entities/Application/AppNavBarImages';
@Component({
  components: {
    LatestNews,
    loading,
    LicenseDetails,
    NotificationPopup,
    // OnboardingInstructions,
    TrialPackageIndicator,
    TopNavBar,
    LeftMenuPanel,
  },
})
class App extends Vue {
  public showLoading = false;
  public isLeftMenuBarShow =  false;
  public mainContentClass = 'main-content';
  public AppColorAndBackgroundColor: any = {
    color: '',
    backgroundColor: '',
    visibility: 'hidden',
  };
  public AppColor: any = { color: '' };
  public AppFontColor = {color: ''};
  private appCss = require('@/assets/css/app.css');
  private mainCss = require('@/assets/css/main.css');
  private modalpopupCss = require('@/assets/css/modalpopup.css');
  private batchoperationsCSS = require('@/assets/css/batchoperations.css');
  private gridlistingCss = require('@/assets/css/gridlisting.css');
  private editPaneCss = require('@/assets/css/editPane.css');
  private landingCss = require('@/assets/css/landingPages.css');
  private listingsCSS = require('@/assets/css/listings.css');
  private toggleCss = require('@/assets/css/toggleswitch.css');
  private sliderCSS = require('@/assets/css/slider.css');
  private dropDownIcon = require('@/assets/Images/down-arrow-white.svg');
  private mobileDropDownIcon = require('@/assets/Images/black-down-arrow.svg');
  private IconFile: string = require('@/assets/Images/VentlaLogo/Ventla-Logo-Grey.svg');
  private helpIcon = require('@/assets//Images/question-mark-icon-base.svg');
  private bellIcon = require('@/assets//Images/notification-base.svg');
  private currentYear: number = new Date().getUTCFullYear();
  private mouseOverOnNotification = false;
  private notificationPopupVisible = false;
  private showLatestNewsPopup = false;
  private showLicenseDetailsPopup = false;
  private showOnboardingPopup = false;
  private ViewModel: ApplicationViewModel = ApplicationViewModel.empty();
  private toggledNav = false;
  private loadingImage: string = require('@/assets/Images/loading-dots-white.gif');
  private showNotificationLoading = false;
  private initialNotificationsCount = 20;
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private meetappSupportURL = 'https://meetappsupport.typeform.com/to/w6PRZh';
  private meetappSignoutURL = '';
  private isLoggedInUserSuperAdmin = false;
  private isLoggedInUserApplicationAdmin = false;
  private isLoggedInUserEventAdmin = false;
  private isLoggedInUserAADAdmin = false;
  private isLoggedinUserOAuthAdmin = false;
  private isaddVideoOverlay = false;
  private isFreezeScreenMsg = false;
  private showNotificationIcon = true;
  private router = useRoute();
  private eventSideMenuIcons: NavBarImages = new NavBarImages();
  private appSideMenuIcons: AppNavBarImages = new AppNavBarImages();
  private isMobile = false;
  private eventsSideMenuItems: EventSideMenu = new EventSideMenu();
  private appSideMenuItems: ApplicationSideMenu = new ApplicationSideMenu();

  private isInsideEvent = false;
  public get selectedComponent(): typeof ModuleTypeEnum {
    return ModuleTypeEnum;
  }
  public get activeComponent(): string {
    return (this.router.name as string) || 'eventsetting';
    }
  public get filteredEventSideMenuItems(): EventSideMenu {
    const filtered = new EventSideMenu();

    filtered.MenuItems = this.eventsSideMenuItems.MenuItems.filter((item) => {
      switch (item.Id) {
      case 'LMSettings':
        return true; // Always visible
      case 'LMWatchLive':
        return this.ShowWatchLive();
      case 'LMRegisrationManager':
        return this.ViewModel.ActiveEvent.EnableRegistrationSystem &&
               this.ViewModel.ApplicationInformation.IsRegistrationPFActive;
      case 'LMEventPage':
        return this.ShowEventWebPage();
      case 'LMProgram':
        return this.ViewModel.ActiveEvent.EnableProgram;
      case 'LMCustomCategory':
        return this.ViewModel.ActiveEvent.EnableInformation;
      case 'LMNotification':
        if (this.ViewModel.ActiveEvent.EnableDialogue) {
          // Patch IsRouterLink based on AllowEnableNewAdmin
          const notifItem = this.eventsSideMenuItems.MenuItems.find((m) => m.Id === 'LMNotification');
          if (notifItem) {
            notifItem.IsRouterLink = this.ViewModel.ApplicationInformation.AllowEnableNewAdmin;
            notifItem.Url = this.ViewModel.ApplicationInformation.AllowEnableNewAdmin
              ? ''
              : '/Admin/Notification/IndexNotification';
          }
          return true;
        }
        return false;
      case 'LMNews':
        return this.ViewModel.ActiveEvent.EnableNewsFeeds;
      case 'LMParticipant':
        return this.ViewModel.ActiveEvent.EnableParticipantList;
      case 'LMAttendance':
        return this.ViewModel.ActiveEvent.EnableParticipantList;
      case 'LMImageGallery':
        return this.ViewModel.ActiveEvent.EnableImageArchive;
      case 'LMActivityFeed':
        return this.ViewModel.ActiveEvent.EnableActivityFeeds;
      case 'LMGamification':
        return this.ViewModel.ActiveEvent.EnableGamification;
      default:
        return true;
      }
    });

    return filtered;
  }

  // Getter to check the set tabs 
  public get leftMenuTabs(): EventSideMenu | ApplicationSideMenu {
    if (this.activeComponent === 'orgsettings') {
      return this.appSideMenuItems;
    }
    return this.isInsideEvent ? this.filteredEventSideMenuItems : this.appSideMenuItems;
  }

  // Getter to set the icons for side menu tabs
  public get leftMenuTabsIconImages(): NavBarImages | AppNavBarImages {
    if (this.activeComponent === 'orgsettings') {
      return this.appSideMenuIcons;
    }
    return this.isInsideEvent ? this.eventSideMenuIcons : this.appSideMenuIcons;
  }

  private CloseLatestNewsPopup() {
    this.showLatestNewsPopup = false;
  }
  private CloseOnboardingPopup() {
    this.showOnboardingPopup = false;
  }
  private closePopup(closePopup: boolean) {
    this.showLicenseDetailsPopup = closePopup;
  }

  private ShowBellIcon() {
    if (window.location.href.indexOf('eventsetting') > -1  || window.location.href.indexOf('watchlive') > -1) {
      this.showNotificationIcon  = false;
      return false;
    } else {
      this.showNotificationIcon = true;
      return true;
    }
  }
  private mounted() {
    app.use(hub);
    app.config.globalProperties.startSignalR(this);
    this.showLoading = true;
    if(window.innerWidth <= 991) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.GetApplicationViewModel();
    Root.on('hide-parent-loader', (hideloader: boolean) => {
      if (hideloader === true) {
        this.showLoading = false;
      }
    });
    Root.on('reload-GetApplicationViewModel', () => {
      this.GetApplicationViewModel();
    });

    Root.on('show-notification-popup', (show: boolean) => {
      if (show === true) {
        this.ShowNotificationPopup();
      } else {
        this.notificationPopupVisible = false;
      }
    });

    Root.on('show-notification-loading', (show: boolean) => {
      if (show === true) {
        this.ShowNotificationLoading();
      } else {
        this.HideNotificationLoading();
      }
    });
    Root.on('freeze-screen', (item: FreezeScreen) => {
      const userName = (item).UserName;
      const val = (item).IsScreenFreezed;
      const storeHelper: StoreHelper = new StoreHelper(Store);
      const reqInfo: AppRequestInfo = storeHelper.GetRequestInfoFromStore();
      if (reqInfo.Username === userName) {
        this.isaddVideoOverlay = val;
        this.isFreezeScreenMsg = val;
      }
    });
    this.CheckLocaleAndTimeFormat();

    Root.on('update-event-name', (val: string) => {
      this.ViewModel.ActiveEvent.Name = val ;
    });
  }
  private GetApplicationViewModel() {
    FetchData('/Application/GetApplicationViewModel','').then((response) => {
      this.ViewModel=new ApplicationViewModel(
        response.ApplicationInformation as ApplicationItem,
        response.Events as EventItem[],
        response.LoggedInUserInformation as UserInformation,
        EnvironmentBaseURL as string,
        response.MuxEnvironmentKey as string,
      );
      this.AppColorAndBackgroundColor={
        color: response.ApplicationInformation.TopNavForegroundColor,
        backgroundColor: response.ApplicationInformation.TopNavBackgroundColor,
        visibility: 'visible',
      };
      this.AppColor={
        color: response.ApplicationInformation.TopNavForegroundColor,
      };
      if(this.ViewModel.ActiveEvent.Id > 0){
        this.isInsideEvent = true;

      }else{
        this.isInsideEvent = false;
      }
      this.AppFontColor.color = response.ApplicationInformation.TopNavBackgroundColor;
      this.SaveValueToStore();
      this.GetSignoutUrl();
      this.showLoading=false;
    })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.log('error');
      });
  }

  private MouseOverNotification(mouseOver: boolean) {
    this.mouseOverOnNotification = mouseOver;
    this.ShowNotificationPopup();
  }
  // Show Popup on click of license details link
  private OpenLicenseDescription(val: boolean) {
    this.showLicenseDetailsPopup = val;
  }

  private created() {
    window.GetVueComponentReference(this);
  }
  private showOnboarding() {
    this.showOnboardingPopup = true;
  }
  private CheckLocaleAndTimeFormat() {
    let locale = window.navigator.language;
    // IE 11 => detect IE 11 browser
    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      locale = locale.split('-')[0];
    }
    const browserSettingsInfo: BrowserSettingsInfo = BrowserSettingsInfo.createEmpty();
    browserSettingsInfo.locale = locale;
    const date = new Date();
    const dateString = date.toLocaleTimeString();
    if (dateString.match(/am|pm/i) || date.toString().match(/am|pm/i) ) {
      // 12 hour clock
      browserSettingsInfo.isFullDayTimeFormat = false;
    } else {
      // 24 hour clock
      browserSettingsInfo.isFullDayTimeFormat = true;
    }
    this.storeHelper.SaveBrowserSettingsToStore(browserSettingsInfo);
  }
  private OpenNewsFlash(val: boolean) {
    this.showLatestNewsPopup = val;
  }
  private SaveValueToStore() {
    const reqInfo: AppRequestInfo = AppRequestInfo.createEmpty();
    reqInfo.ApplicationId = this.ViewModel.ApplicationInformation.Id;
    reqInfo.ApplicationInstanceId = this.ViewModel.ActiveEvent.Id;
    if(reqInfo.ApplicationInstanceId > 0 || (this.router.name === 'orgsettings')) {
      this.isLeftMenuBarShow = true;
      this.mainContentClass = 'main-content';
    } else {
      this.mainContentClass = 'main-content1';
    }
    const currentUrl = window.location.href;
    if(currentUrl.includes('eventsetting')) {
      this.showNotificationIcon = false;
    } else {
      this.showNotificationIcon = true;
    }
    reqInfo.Authorization = Authorization;
    reqInfo.EnvironmentBaseURL = EnvironmentBaseURL;
    reqInfo.SignalRBaseURL = app.config.globalProperties.$SignalRBaseURL;
    reqInfo.UserId = this.ViewModel.LoggedInUserInformation.UserId;
    reqInfo.Username = this.ViewModel.LoggedInUserInformation.Username;
    reqInfo.AdminType = this.ViewModel.LoggedInUserInformation.AdminTypeForUpperRightCorner;
    reqInfo.FirstName = this.ViewModel.LoggedInUserInformation.Firstname;
    reqInfo.LastName = this.ViewModel.LoggedInUserInformation.Lastname;
    reqInfo.UserEmail = this.ViewModel.LoggedInUserInformation.Email;
    reqInfo.UserHash = this.ViewModel.LoggedInUserInformation.UserHash;
    reqInfo.MuxEnvironmentKey = this.ViewModel.MuxEnvironmentKey;
    reqInfo.AllowEnableTimeZoneFeature = this.ViewModel.ApplicationInformation.AllowEnableTimeZoneFeature;
    reqInfo.EnableVirtualMeetingIntegration = this.ViewModel.ApplicationInformation.EnableVirtualMeetingIntegration;
    reqInfo.EnableIntegrateteamszoomWatchLive = this.ViewModel.ApplicationInformation.EnableIntegrateteamszoomWatchLive;
    reqInfo.EnableVimeoVideos = this.ViewModel.ApplicationInformation.EnableVimeoVideos;
    reqInfo.EnableVideoOnDemandCustomCategory = this.ViewModel.ApplicationInformation.EnableVideoOnDemandCustomCategory;
    reqInfo.EnableRankingDialogue = this.ViewModel.ApplicationInformation.EnableRankingDialogue;
    reqInfo.EnableMeetAppLive = this.ViewModel.ApplicationInformation.EnableMeetAppLive;
    reqInfo.EnableScalingDialogue = this.ViewModel.ApplicationInformation.EnableScalingDialogue;
    reqInfo.EnableVideoOnDemand = this.ViewModel.ApplicationInformation.EnableVideoOnDemand;
    reqInfo.EnableMeetAppLiveArchiving = this.ViewModel.ApplicationInformation.EnableMeetAppLiveArchiving;
    reqInfo.IsCurrentPackageTrial = this.ViewModel.ApplicationInformation.IsCurrentPackageTrial;
    reqInfo.EnableParticipantList = this.ViewModel.ActiveEvent.EnableParticipantList;
    reqInfo.EnableLinkProgramItemsToGroup = this.ViewModel.ApplicationInformation.EnableLinkProgramItemsToGroup;
    reqInfo.EnableLinkParticipantToInformation = this.ViewModel.ApplicationInformation.EnableLinkParticipantToInformation;
    reqInfo.IsApplicationOnNewPackage = this.ViewModel.ApplicationInformation.IsApplicationOnNewPackage;
    reqInfo.IsDepartmentAdminFeatureEnable = this.ViewModel.ApplicationInformation.IsDepartmentAdminFeatureEnable;
    reqInfo.IsApplicationAdmin = this.ViewModel.LoggedInUserInformation.IsApplicationAdmin;
    reqInfo.IsLiveStreamingActive = this.ViewModel.ApplicationInformation.IsLiveStreamingActive;
    reqInfo.VerifyThresholdLimit = this.ViewModel.ApplicationInformation.VerifyThresholdLimit;
    reqInfo.IsThresholdLimitReached = this.ViewModel.ApplicationInformation.IsThresholdLimitReached;
    reqInfo.IsDepartmentAdmin = this.ViewModel.LoggedInUserInformation.IsDepartmentAdmin;
    reqInfo.DepartmentId = this.ViewModel.LoggedInUserInformation.DepartmentId;
    reqInfo.IsEventAdmin = this.ViewModel.LoggedInUserInformation.IsEventAdmin;
    reqInfo.IsSuperAdmin = this.ViewModel.LoggedInUserInformation.IsSuperAdmin;
    reqInfo.MaxAllowedAppInstances = this.ViewModel.ApplicationInformation.MaxAllowedAppInstances;
    reqInfo.TotalConsumedEvents = this.ViewModel.ApplicationInformation.TotalConsumedEvents;
    reqInfo.ThrehsholdEventsNumber = this.ViewModel.ApplicationInformation.ThrehsholdEventsNumber;
    reqInfo.CurrentEventsNumber = this.ViewModel.ApplicationInformation.CurrentEventsNumber;
    reqInfo.AdditionalEvents = reqInfo.ThrehsholdEventsNumber - reqInfo.CurrentEventsNumber;
    reqInfo.CreateAccountType = this.ViewModel.ApplicationInformation.CreateAccountType;
    reqInfo.CreateAccountTypeId = this.ViewModel.ApplicationInformation.CreateAccountTypeId;
    reqInfo.IsRegistrationPFActive = this.ViewModel.ApplicationInformation.IsRegistrationPFActive;
    reqInfo.EnableRTMPOnEventSettings = this.ViewModel.ApplicationInformation.EnableRTMPOnEventSettings;
    reqInfo.IsParticipantSelfCheckInActive = this.ViewModel.ApplicationInformation.IsParticipantSelfCheckInActive;
    reqInfo.LogoURI = this.ViewModel.ApplicationInformation.LogoUri;
    reqInfo.LogoUriDarkMode = this.ViewModel.ApplicationInformation.LogoUriDarkMode;
    reqInfo.EnableDialogueThemes = this.ViewModel.ApplicationInformation.EnableDialogueThemes;
    reqInfo.EnableCustomMenuNames = this.ViewModel.ApplicationInformation.EnableCustomMenuNames;
    reqInfo.EnableUserEditedParticipant = this.ViewModel.ApplicationInformation.EnableUserEditedParticipant;
    reqInfo.IsEventWebPagePFActive = this.ViewModel.ApplicationInformation.IsEventWebPagePFActive;
    reqInfo.EnableEventWebPage = this.ViewModel.ActiveEvent.EnableEventWebPage;
    reqInfo.IsZapierPFActive = this.ViewModel.ApplicationInformation.IsZapierPFActive;
    reqInfo.ZapierKey = this.ViewModel.ApplicationInformation.ZapierKey;
    reqInfo.IsZapierAvailableInApplicationZapierCallback = this.ViewModel.ApplicationInformation.IsZapierAvailableInApplicationZapierCallback;
    reqInfo.EnableCustomBranding = this.ViewModel.ApplicationInformation.EnableCustomBranding;
    reqInfo.EnablePrivateChat = this.ViewModel.ApplicationInformation.EnablePrivateChat;
    reqInfo.EnablePersonalisedEventAccessLink = this.ViewModel.ApplicationInformation.EnablePersonalisedEventAccessLink;
    reqInfo.IsWhiteLabelledDomainsPFActive = this.ViewModel.ApplicationInformation.IsWhiteLabelledDomainsPFActive;
    reqInfo.OfferTickets             = this.ViewModel.ActiveEvent.OfferTickets;
    reqInfo.EnableRegistrationSystem = this.ViewModel.ActiveEvent.EnableRegistrationSystem;

    this.storeHelper.SaveValueToStore(reqInfo);
    this.storeHelper.SaveActiveEventStartDate(this.ViewModel.ActiveEvent.StartDate);
    this.storeHelper.SaveActiveEventIanaTimeZone(this.ViewModel.ActiveEvent.IanaTimeZone);
    this.storeHelper.SaveEnableProgramQuestionValue(this.ViewModel.ApplicationInformation.EnableProgramQuestion);
    this.storeHelper.SaveEnableProgram(this.ViewModel.ActiveEvent.EnableProgram);
    this.storeHelper.SaveEnableInformation(this.ViewModel.ActiveEvent.EnableInformation);
    this.storeHelper.SaveEnableMessagingfeature(this.ViewModel.ActiveEvent.EnableMessagingfeature);
    const appDefaultColorsInfo: AppColorSettingsInfo = AppColorSettingsInfo.createEmpty();
    appDefaultColorsInfo.topNavForegroundColor = this.ViewModel.ApplicationInformation.TopNavForegroundColor;
    appDefaultColorsInfo.topNavBackgroundColor = this.ViewModel.ApplicationInformation.TopNavBackgroundColor;
    this.storeHelper.SaveAppColorSettingsToStore(appDefaultColorsInfo);
    this.storeHelper.SaveEventNameToStore(this.ViewModel.ActiveEvent.Name);
    this.storeHelper.SaveConsumptionBasedProductPricingToStore(this.ViewModel.ApplicationInformation.ConsumptionBasedProductPricing!);
    if(this.ViewModel.ActiveEvent.Id > 0) {
      this.FillNotificationsPopup();
    }
    Root.emit('reload-eventsettingtab');
  }
  private GetLoggedInUserName() {
    const adminFirstName = this.ViewModel.LoggedInUserInformation.Firstname;
    const adminLastName = this.ViewModel.LoggedInUserInformation.Lastname;
    return adminFirstName + ' ' + adminLastName;
  }
  private OpenHelpLink() {
    window.open('https://support.ventla.io/kb/', '_blank', 'noreferrer');
  }
  private FillNotificationsPopup() {
    const signalR: ProgramSignalRModel = new ProgramSignalRModel(
      Root,
      Store,
      this.$t,
    );
    signalR.GetInitialNotifications(this.initialNotificationsCount);
  }

  private ToggleNotificationPopup(event: any) {
    if(this.notificationPopupVisible) {
      this.HideNotificationPopup();
    } else {
      this.ShowNotificationPopup();
    }
    event.stopPropagation();

  }
  private GetCurrentModuleName() {
    if(this.ViewModel.ActiveEvent.Id > 0) {
      switch(this.activeComponent) {
      case 'eventsetting':
        return this.$t('Settings').toUpperCase();
      case 'watchlive':
        return this.activeComponent.toUpperCase();
      case 'eventpage':
        return this.activeComponent.toUpperCase();
      case 'program':
        return this.activeComponent.toUpperCase();
      case 'customCategory':
        return this.$t('Information').toUpperCase();
      case 'notification':
        return this.$t('Dialogue').toUpperCase();
      case 'participants':
        return this.$t('Participants').toUpperCase();
      case 'invite':
        return this.$t('Registrationmanager').toUpperCase();
      case 'attendees':
      case 'groups':
      case 'myinformation':
        return this.$t('Attendance').toUpperCase();
      }
    } else {
      return this.$t('CreateNewEvent').toUpperCase();
    }
  }
  private ShowNotificationPopup() {
    this.notificationPopupVisible = true;
    Root.emit(
      'reload-all-notifications',
    );
    setTimeout(() => {
      this.HideNotificationPopup();
    }, 3000);
  }

  private HideNotificationPopup() {
    if (!this.mouseOverOnNotification) {
      this.notificationPopupVisible = false;
    }
  }

  private ShowNotificationLoading() {
    this.showNotificationLoading = true;
  }
  private HideNotificationLoading() {
    this.showNotificationLoading = false;
  }
  private CheckAndHideNotificationPopup() {
    if (this.notificationPopupVisible === true) {
      this.notificationPopupVisible = false;
    }
  }

  private GetSignoutUrl() {
    if (this.ViewModel.ApplicationInformation.EnableCustomOAuthAuthorization) {

      this.meetappSignoutURL = EnvironmentBaseURL + '/Admin/Auth/AuthSignOut?Id=' + this.ViewModel.ApplicationInformation.Id;
    } else {
      this.meetappSignoutURL = EnvironmentBaseURL + '/Admin/Auth/SignOut';
    }
  }
  private ShowWatchLive(): boolean {
    if(this.ViewModel.ActiveEvent.Id > 0) {
      if(this.ViewModel.ApplicationInformation.IsLiveStreamingActive && this.ViewModel.ActiveEvent.EnableLiveStreaming) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  private ShowEventWebPage() {
    if(this.ViewModel.ActiveEvent.Id > 0) {
      if(this.ViewModel.ApplicationInformation.IsEventWebPagePFActive && this.ViewModel.ActiveEvent.EnableEventWebPage) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
export default toNative(App);
